module.exports = __webpack_public_path__ + "img/tutorial_starter_data.a86750ca.png";